import { render, staticRenderFns } from "./PrivacyButton.vue?vue&type=template&id=6a448194&"
import script from "./PrivacyButton.vue?vue&type=script&lang=js&"
export * from "./PrivacyButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports